import { render, staticRenderFns } from "./UserLevels.vue?vue&type=template&id=a716f508&scoped=true&"
import script from "./UserLevels.vue?vue&type=script&lang=js&"
export * from "./UserLevels.vue?vue&type=script&lang=js&"
import style0 from "./UserLevels.vue?vue&type=style&index=0&id=a716f508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a716f508",
  null
  
)

export default component.exports